import { Component, OnInit, Input } from '@angular/core';
import {ProfileSearchResult} from '../../data/ProfileSearchResult';

@Component({
  selector: 'app-search-form-exists',
  templateUrl: './search-form-exists.component.html',
  styleUrls: ['./search-form-exists.component.css']
})
export class SearchFormExistsComponent implements OnInit {
  @Input() results: ProfileSearchResult;

  constructor() { }

  ngOnInit() { }
}
